module.exports = __webpack_public_path__ + "img/SW125_MemoryShare_Final-10.f3ac472d.png";